import $http from '@vue-util/http';
import { RETURNS_BASE_PATH } from '#shared/endpoints';
import { createHeaders } from '@/utils/CreateHeaders';
import { prepareReturnLabelPayload } from '@/utils/returns/General';

export const useReturnConfirmationStore = defineStore('returnConfirmationStore', {
  state: () => ({
    returnDetails: null,
    returnLabel: {
      showNotification: false,
      emailAddress: '',
      error: false,
      loading: '',
    },
  }),

  actions: {
    SET_RETURN_CONFIRMATION(returnDetails) {
      this.returnDetails = returnDetails;
    },

    SET_SHOW_RETURNLABEL_NOTIFICATION(payload) {
      this.returnLabel.emailAddress = payload.emailAddress;
      this.returnLabel.showNotification = payload.showReturnLabelNotification;

      if (payload.rmaId) {
        this.returnLabel.rmaId = payload.rmaId;
      }
    },

    SET_RETURNLABEL_ERROR({ error, rmaId }) {
      this.returnLabel.error = error;
      if (rmaId) {
        this.returnLabel.rmaId = rmaId;
      }
    },

    SET_LOADER(loader = '') {
      this.returnLabel.loading = loader;
    },

    SET_ID(id = '') {
      this.returnLabel.showForm = id;
    },

    async SEND_RETURN_LABEL_EMAIL({ emailAddress, rmaId }) {
      this.SET_LOADER(rmaId);
      const { returnResponse, returnDetails } = this.returnDetails;

      try {
        const url = `${RETURNS_BASE_PATH}/resend-label`;
        let payload;
        let labelUrl;

        if (rmaId) {
          const { resendLabelPayload, resendLabelToken } = prepareReturnLabelPayload(returnResponse[0], rmaId);
          payload = { returnDetails: resendLabelPayload };
          labelUrl = resendLabelToken;
        } else {
          payload = { returnDetails };
          labelUrl = returnDetails?.labelUrl;
        }

        const headers = createHeaders();
        const options = {
          ...headers,
          params: {
            verifyLookup: 'true',
            lookupParams: decodeURIComponent(labelUrl),
            resendEmailId: emailAddress,
          },
        };

        await $http.post(url, payload, options);

        this.SET_SHOW_RETURNLABEL_NOTIFICATION({
          emailAddress,
          showReturnLabelNotification: true,
          rmaId,
        });
      } catch (error) {
        this.SET_RETURNLABEL_ERROR({ error: true, rmaId });
        throw error;
      } finally {
        this.SET_LOADER();
      }
    },

    CLEAR_RETURN_CONFIRMATION() {
      this.SET_RETURN_CONFIRMATION(null);
      this.SET_SHOW_RETURNLABEL_NOTIFICATION({
        emailAddress: '',
        showReturnLabelNotification: false,
        error: false,
        loading: '',
      });
      this.SET_RETURNLABEL_ERROR({ error: false });
      this.SET_LOADER();
    },
  },
});
